import styled from "styled-components";
import { useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Widget, WidgetLoader } from "datastake-daf/dist/components";
import useDataAccumulation from "./hook";

const Style = styled.div`
  height: 250px;
  width: calc(100% - 48px);
`;

export default function DataAccumulation({
  filter,
  loading,
  data = {},
}) {
  const container = useRef();
  const { t } = useTranslation();

  const activeData = useMemo(() => data[filter] || {}, [data, filter]);

  useDataAccumulation({ container, data: activeData, filter });

  return (
    <Widget
      title={t('DataStore::data-accumulation')}
      className="with-border-header no-px-body overflow-hidden flex-1"
    >
      {!!loading && <WidgetLoader background="white" />}
      <div className='flex flex-1 flex-column justify-content-center'>
        <div className='flex justify-content-center'>
          <Style ref={container} />
        </div>
      </div>
    </Widget>
  )
}
